import React, {useRef, useState} from "react";
import {GatsbyImage} from "gatsby-plugin-image";
import {useScrollMonitor} from "scrollmonitor-hooks";
import ArrowLink from "../global/arrow-link";

const StaticBanner = (
  {
    imageData = null,
    contentPosition = 'default',
    projectData = null,
    children
  }
) => {
  const parentRef = useRef(null);
  const [bannerViewClass, setBannerViewClass] = useState('');

  const cardViewCallbacks = {
    enterViewport: () => {
      setBannerViewClass('banner--in-view');
    }
  }

  useScrollMonitor(parentRef, cardViewCallbacks);

  return (
    <section
      className={`banner ${bannerViewClass}`}
      ref={parentRef}
    >
      <div className="banner__media-wrapper">
        <GatsbyImage
          className="banner__image"
          image={imageData}
          alt="Evo"
        />
      </div>
      {projectData?.link.title && (
        <div className={`banner__content-wrapper banner__content-wrapper--${contentPosition}`}>
          <h2 className={`banner__title banner__title--${contentPosition}`}>{children}</h2>
          {projectData?.link.title && (
            <ArrowLink
              text={projectData.link.title}
              to={projectData.link.url}
            />
          )}
        </div>
      )}
    </section>
  )
}

export default StaticBanner
